import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Onboarding from "@/pages/onboarding/Onboarding";
import AppShell from "@/pages/AppShell";
import Tower from "@/pages/modules/Tower";
import Radar from "@/pages/modules/Radar";
import Runway from "@/pages/modules/Runway";
import Hangar from "@/pages/modules/Hangar";
import Planner from "@/pages/modules/Planner";
import Nest from "@/pages/modules/Nest";
import AdminWaitlist from "@/pages/admin/Waitlist";
import Household from "@/pages/Household";
import JoinHousehold from "@/pages/JoinHousehold";
import { About, Manifesto, Contact } from "@/pages/marketing/MarketingPages";
import RequireAuth from "@/components/RequireAuth";
import RequireOnboarded from "@/components/RequireOnboarded";

function AppRouter() {
  const location = useLocation();
  // SYNCHRONOUS render-time check (per Emergent Auth playbook) — must run
  // BEFORE any protected-route effect fires to avoid a 401 race.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/join/:token" element={<JoinHousehold />} />
      <Route path="/about" element={<About />} />
      <Route path="/manifesto" element={<Manifesto />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/preview" element={<Navigate to="/login" replace />} />
      <Route
        path="/app/onboarding"
        element={
          <RequireAuth>
            <Onboarding />
          </RequireAuth>
        }
      />
      <Route
        path="/app"
        element={
          <RequireAuth>
            <RequireOnboarded>
              <AppShell />
            </RequireOnboarded>
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="tower" replace />} />
        <Route path="tower" element={<Tower />} />
        <Route path="radar" element={<Radar />} />
        <Route path="runway" element={<Runway />} />
        <Route path="hangar" element={<Hangar />} />
        <Route path="planner" element={<Planner />} />
        <Route path="nest" element={<Nest />} />
        <Route path="household" element={<Household />} />
        <Route path="admin/waitlist" element={<AdminWaitlist />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#0C1525",
              color: "#F4F1ED",
              border: "1px solid #192A45",
              borderRadius: 0,
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
